import { useToast } from '@skillstown/leap';
const { createToast } = useToast();

export function validateCaptcha(action: string = 'submit'): Promise<string> {
  return new Promise((resolve) => {
    grecaptcha.ready(() => {
      try {
        grecaptcha
          .execute(import.meta.env.VITE_APP_RECAPTCHA_KEY, {
            action: action
          })
          .then((token: string) => {
            return resolve(token);
          });
      } catch (error) {
        createToast({
          variant: 'error',
          label: 'Error',
          text: String(error)
        });
      }
    });
  });
}
